import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, shareReplay } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { CuentaBancaria } from '../../../../models/maestros/cuenta-bancaria.model';

@Injectable({
  providedIn: 'root',
})
export class CuentaBancariaService {
  private readonly apiUrl = environment.apiUrl;
  private readonly endpoint = `${this.apiUrl}/maestras/cuenta-bancaria`;

  private cuentasBancariasVigor?: Observable<CuentaBancaria[]>;
  private cuentasBancariasTodos?: Observable<CuentaBancaria[]>;

  constructor(private readonly http: HttpClient) {}

  getCuentasBancariasVigor(): Observable<CuentaBancaria[]> {
    if (!this.cuentasBancariasVigor) {
      this.cuentasBancariasVigor = this.http.get<CuentaBancaria[]>(this.endpoint).pipe(
        shareReplay(1), // Cachear el último valor emitido
        catchError((error) => {
          console.error('CuentaBancariaService - Error fetching data:', error);
          throw error;
        })
      );
    }
    return this.cuentasBancariasVigor;
  }

  getCuentasBancariasTodos(): Observable<CuentaBancaria[]> {
    if (!this.cuentasBancariasTodos) {
      this.cuentasBancariasTodos = this.http.get<CuentaBancaria[]>(this.endpoint.concat('/todos')).pipe(
        shareReplay(1), // Cachear el último valor emitido
        catchError((error) => {
          console.error('CuentaBancariaService - Error fetching data:', error);
          throw error;
        })
      );
    }
    return this.cuentasBancariasTodos;
  }

  setComboCuentasBancariasAsync(cuentasBancarias: CuentaBancaria[], hasNull = false): void {
    this.getCuentasBancariasVigor().subscribe({
      next: (data) => {
        if (hasNull) {
          data.unshift({ id: null } as unknown as CuentaBancaria);
        }

        cuentasBancarias.push(...data);
      },
      error: (error) => {
        console.error('CuentaBancariaService - Error fetching data:', error);
      },
    });
  }

  setComboCuentasBancariasByEmpresaRefacturadoraAsync(
    cuentasBancarias: CuentaBancaria[],
    idEmpresaFacturadora: number,
    hasNull = false
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.getCuentasBancariasVigor().subscribe({
        next: (data) => {
          if (hasNull) {
            cuentasBancarias.unshift({ id: null } as unknown as CuentaBancaria);
          }

          const filteredData = data.filter((cuenta) => cuenta.idEmpresaFacturadora == idEmpresaFacturadora);
          cuentasBancarias.push(...filteredData);
          resolve();
        },
        error: (error) => {
          console.error('CuentaBancariaService - Error fetching data:', error);
          reject(new Error('Error fetching cuentas bancarias'));
        },
      });
    });
  }
}
